const baseUrl = "https://hom-sisdemanda.artesp.sp.gov.br";

export const environment = {
    msal: {
        clientId: '09b85dc4-a26e-427d-80d6-28ba7e9ab81a',
        tenantId: '23ce5604-35af-46cc-8f0e-21d715c7f9fb',
        redirectUri: `${baseUrl}/auth/redirect-callback`,
    },
    api: {
        uri: `${baseUrl}/api/sisdemanda-publico/`,
        uriGovbr: `${baseUrl}/api/sisdemanda-publico/gov`,
    },
    google: {
        mapKey: 'AIzaSyAcxNsX9uBbO3X6D0atcbljaD1nyFe35hY',
        mapId: 'a22809bfb4f66b58',
    },
    baseUrl: baseUrl,
    uriGovBr: 'https://sso.staging.acesso.gov.br',
    version: '2.0.0',
    name: 'SISDEMANDA'
}
